import { Box, MenuItem } from '@mui/material';
import { HorizontalForm, CustomTextField, CustomSelect } from '../../../../common/components';
import { TEMPLATE_TYPE_OPTIONS } from '../constants/taskTemplatesConstants';

/**
 * Componente de filtros para plantillas de tareas
 */
const TaskTemplatesFilters = ({ filter, onFilter }) => {
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    onFilter(name, value);
  };

  return (
    <HorizontalForm>
      <Box
        sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', md: 'row' }, width: '100%' }}
      >
        <CustomTextField
          label="Buscar"
          name="search"
          value={filter.search}
          onChange={handleFilterChange}
          placeholder="Buscar por nombre o descripción..."
          size="medium"
          fullWidth
          sx={{ width: { xs: '100%', md: 'auto' }, minWidth: { md: '300px' } }}
        />

        <CustomSelect
          label="Tipo de Plantilla"
          name="templateType"
          value={filter.templateType}
          onChange={handleFilterChange}
          size="medium"
          fullWidth
          sx={{ width: { xs: '100%', md: 'auto' }, minWidth: { md: '300px' } }}
        >
          {TEMPLATE_TYPE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </CustomSelect>
      </Box>
    </HorizontalForm>
  );
};

export default TaskTemplatesFilters;
